var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{directives:[{name:"key",rawName:"v-key",value:(`${_vm.dialogueCollection.cid}-${_vm.useResponses}`),expression:"`${dialogueCollection.cid}-${useResponses}`"}],staticClass:"view-conversation-dialogue"},_vm._l((_vm.dialogueCollection),function(dialogueModel,index){return _c('ViewSpeechBubble',{key:dialogueModel.text,class:{
			'animate-in': _vm.currentIndex === index,
			'animate-out': _vm.currentIndex !== index && index < _vm.currentIndex,
		},attrs:{"dialogueModel":dialogueModel,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }